// extracted by mini-css-extract-plugin
export default {"td":"TableItemName_td__DGI8g","tooltip":"TableItemName_tooltip__AvDFa"};